import React from "react";
import NewInvoiceContent from "../components/trips/new-invoice-content";

const NewInvoice = () => {
    return <NewInvoiceContent />;
}

export default NewInvoice;